module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/schedule-2-2-00c5dceededaf886d6faf6622045a7db.jpg";